import axios from 'axios';
import WebApi from '../WebApi';
class AccountApi extends WebApi {
    async fetchData(user_id) {
        return axios.get(`${this.urlPrefix}/accounts/${user_id}`);
    }
    async putData(user_id) {
        return axios.put(`${this.urlPrefix}/accounts/${user_id}`);
    }
    async patchData(user_id) {
        return axios.patch(`${this.urlPrefix}/accounts/${user_id}`);
    }
    async sendAvatarUser({ avatar }, userId) {
        return axios.put(`${this.urlPrefix}/users/${userId}/upload_avatar`, avatar, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    ;
    async sendInvitationUser(user) {
        return axios.post(`${this.urlPrefix}/users/invite`, {
            user,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getRecapDate(account_id) {
        return axios.get(`${this.urlPrefix}/account_onboarding/accounts/${account_id}/recap`);
    }
    async publishAccount(account_id) {
        return axios.put(`${this.urlPrefix}/account_onboarding/accounts/${account_id}/publish`);
    }
    async fetchAccountTitles() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/saas_state`);
        return data;
    }
    async fetchSubAccounts() {
        const { data } = await axios.get(`${this.urlPrefix}/sub_accounts`);
        return data.sub_accounts;
    }
}
const accountApi = new AccountApi();
export { accountApi as AccountApi, };
